import React from "react"
import "./button.sass"
import IconDoc from "../images/driver/icon-doc@2x.png"
import classNames from "classnames"

const Button = ({ styles, className, onClick, to = "/", icon = IconDoc, children }) => {
  const handleClick = e => {
    if (typeof onClick === "function") {
      e.preventDefault()
      onClick.call(null, e)
    }
  }
  return (
    <a href={to} target="_blank" onClick={handleClick} className={classNames("button", { [className]: className })} style={{ ...styles }}>
      <i className="icon icon-doc" style={{ backgroundImage: `url(${icon})` }}>
        &
      </i>
      {children}
    </a>
  )
}

export default Button
